import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
} from "@mui/material";
import Select from "react-select";
import CustomButton from "src/components/CustomButton";

interface VerifyEventsDialogProps {
  verifyingData: string | null;
  setVerifyingData: React.Dispatch<React.SetStateAction<string | null>>;
  handleVerify: (
    eventId: string,
    status: string,
    reason: string,
    className?: string
  ) => void;
  verifyDataValue: string;
  reason: string;
  setVerifyDataValue: React.Dispatch<React.SetStateAction<string>>;
  setReason: React.Dispatch<React.SetStateAction<string>>;
  label: string;
  className?: string;
  setClassName?: React.Dispatch<React.SetStateAction<string>>;
}

const VerifyEventsDialog = ({
  verifyingData,
  setVerifyingData,
  handleVerify,
  verifyDataValue,
  reason,
  setVerifyDataValue,
  setReason,
  label,
  className,
  setClassName,
}: VerifyEventsDialogProps) => {
  return (
    <Dialog
      open={!!verifyingData}
      onClose={() => {
        setClassName && setClassName("");
        setVerifyingData(null);
        setVerifyDataValue("");
      }}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          height: "400px", // Fixed height
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogTitle>Verify {label}</DialogTitle>
      <DialogContent style={{ flex: 1, overflow: "auto" }}>
        <FormControl fullWidth sx={{ zIndex: "9999", marginBottom: "4px" }}>
          <Select
            value={
              verifyDataValue
                ? { value: verifyDataValue, label: verifyDataValue }
                : null
            }
            placeholder="Select Status"
            onChange={(option) => setVerifyDataValue(option?.value || "")}
            options={[
              { value: "APPROVED", label: "Approved" },
              { value: "REJECTED", label: "Rejected" },
              { value: "PENDING", label: "Pending" },
            ]}
          />
        </FormControl>
        {setClassName && (
          <FormControl
            fullWidth
            sx={{ zIndex: "999", marginBottom: "4px", marginTop: 1 }}
          >
            <Select
              placeholder="Select Class"
              value={className ? { value: className, label: className } : null}
              onChange={(option) => setClassName(option?.value ?? "")}
              options={[
                { value: "A", label: "A" },
                { value: "B", label: "B" },
                { value: "C", label: "C" },
              ]}
            />
          </FormControl>
        )}

        <TextField
          margin="dense"
          label="Reason"
          fullWidth
          variant="outlined"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          rows={4}
        />
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={() => setVerifyingData(null)} variant="outlined">
          Cancel
        </CustomButton>
        <CustomButton
          onClick={() => {
            if (verifyingData && verifyDataValue) {
              handleVerify(verifyingData, verifyDataValue, reason, className);
            }
          }}
          style={{
            color: "#ffffff",
            ...(verifyDataValue && !(verifyDataValue === "REJECTED" && !reason)
              ? {}
              : {
                  backgroundColor: "#cccccc",
                  cursor: "not-allowed",
                  color: "#bbbbbb",
                }),
          }}
          disabled={
            !verifyDataValue || (verifyDataValue === "REJECTED" && !reason)
          }
        >
          Verify
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default VerifyEventsDialog;
